export const colors = [
    "#E07A5F",
    "#3D405B",
    "#81B29A",
    "#F2CC8F",
    "#F0C2A3",
    "#E7C2E7",
];
